import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { isMobile, isTablet } from "react-device-detect";

import { IReminderType } from '../../../store/ReminderTypeStore';

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: any;
  addTab: any;
  items: any;
}

const ReminderTypeListItem = (props: IProps) => {

  const { pageSizeChanged, pageNoChanged, addTab } = props;
  const items = props.items.Data;
  const paging = props.items.Paging;

  const onPage = (event: any) => {

    const { page, rows } = event;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };

  const setDetail = (row: IReminderType, val: string) => {
    return (
      <span className="info-sub-head cursor-pointer" onClick={() => addTab(row)} >
        <strong className="opt-l-number">
          {val}
        </strong>
      </span>
    );
  };

  const setResponsiveContents = (title: string, contents: any, isTitle: boolean = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };

  const setNormalDataTable = () => {
    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}
        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable scrollHeight="calc(100vh - 390px)"
      >
        <Column field="ReminderTypeId" header="Id" body={(r: IReminderType) => setDetail(r, r.ReminderTypeId)} style={{ width: '5rem' }} />
        <Column field="Name" header="Name" body={(r: IReminderType) => setDetail(r, r.Name)} />
        <Column field="CategoryName" header="Category" body={(r: IReminderType) => setDetail(r, r.CategoryName)} />
        <Column field="SubCategoryName" header="Subcategory" body={(r: IReminderType) => setDetail(r, r.SubCategoryName)} />
        <Column field="Name" header="Type Name" body={(r: IReminderType) => setDetail(r, r.Name)} />
        <Column field="Code" header="Type Code" body={(r: IReminderType) => setDetail(r, r.Code)} />
      </DataTable>
    );
  };


  const setResponsiveDataTable = () => {
    return (
      <DataTable
        header='Reminder Type'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column header="Id" body={(r: IReminderType) => setResponsiveContents('Type Id', setDetail(r, r.ReminderTypeId))} />
        <Column header="Category" body={(r: IReminderType) => setResponsiveContents('Category', setDetail(r, r.CategoryName))} />
        <Column header="Subcategory" body={(r: IReminderType) => setResponsiveContents('Subcategory', setDetail(r, r.SubCategoryName))} />
        <Column header="Name" body={(r: IReminderType) => setResponsiveContents('Name', setDetail(r, r.Name))} />
        <Column header="Code" body={(r: IReminderType) => setResponsiveContents('Code', setDetail(r, r.Code))} />
      </DataTable>
    );
  };

  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );
};

export default ReminderTypeListItem;